export default "__VITE_ASSET__CxB23qrb__"